<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>Veranstaltungsformular ausfüllen</span>
			</div>
			<mat-spinner diameter=30 [ngStyle]="{ opacity: bInProgress ? 1 : 0 }" />
			
		</div>

		<div style="padding:1em; margin: 0em auto 0 auto; position: relative">

			@if( !bInProgress && !categoryId ) {
				<div class="errorMessage">
					Ungültiges Ereignis, es hat keine Kategorie
				</div>
			}

			<dynamic-form
				*ngIf="categoryId"
				[categoryId]="categoryId"
				(submit)="onSubmit($event)"
			/>

			@if( bErrorSubmitting ) {
				<div class="errorWarning" style="text-align: center;">
					Beim Absenden des Formulars ist ein Fehler aufgetreten
				</div>
			}

		</div>

	</div>

</div>

